import { IRoadmap } from "@/shared/types/roadmap";
import { useEffect, useState } from "react";
import useRoadmaps from "../../hooks/useRoadmaps";
import { useSelector } from "react-redux";
import { RootState } from "@/store/redux/store";
import { IRoute } from "@/api/roadmaps/types";

function useRoadmapsBSI() {
    const { getRoadmapsByBusstaition } = useRoadmaps();
    const { busStation, roadmaps, roadmap, mapMode } = useSelector((state: RootState) => state.mapScreen);
    const [initRoutes, setIniRoutes] = useState<IRoadmap[]>([]);
    const [routes, setRoutes] = useState<IRoadmap[]>([]);
    const [isLowFloorTransportEnabled, setisLowFloorTransportEnabled] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedRouteNames, setSelectedRouteNames] = useState<string[]>([]);

    useEffect(() => {
        if (selectedRouteNames && initRoutes) {
            const filtres = initRoutes.map((r) => {
                if (selectedRouteNames.includes(r.route_name)) {
                    return r;
                }
            }).filter((r) => r !== undefined);
            setRoutes(selectedRouteNames.length > 0 ? filtres : initRoutes);
        }
    }, [selectedRouteNames])

    // useEffect(() => {
    //     let filteredRoadmaps = initRoutes
    //     if (mapMode === 'query') {
    //         console.log(roadmaps)
    //         // const filtered = filteredRoadmaps.filter((r: IRoadmap) => {
    //         //     return r.route_id.toString() === roadmaps[0].route_id.toString();
    //         // })
    //         //setRoutes(filtered);
    //     } else {
    //         setRoutes(filteredRoadmaps);
    //     }
    //     // if (initRoutes) {
    //     //     if (isLowFloorTransportEnabled) {
    //     //         let filteredRoadmaps = initRoutes.filter((roadmap: IRoadmap) => roadmap.low_floor.toString() === '1');
    //     //         if (mapMode === 'query') {
    //     //             const filtered = filteredRoadmaps.filter((r: IRoadmap) => {
    //     //                 return r.route_id.toString() === roadmap.route_id.toString();
    //     //             })
    //     //             setRoutes(filtered);
    //     //         } else {
    //     //             setRoutes(filteredRoadmaps);
    //     //         }
    //     //     } else {
    //     //         setRoutes(initRoutes);
    //     //     }
    //     // }
    // }, [initRoutes, roadmaps, mapMode]);

    function getPrefix(id: any): string {
        return (id ?? '').toString().split('_')[0];
    }

    async function getRoutesByStaition() {
        const res = await getRoadmapsByBusstaition();
        console.log('getRoutesByStaition', res)
        let names = [];
        if (roadmap) {
            const filtred = res.filter((road) =>
                getPrefix(road.route_id) === getPrefix(roadmap.route_id) ||
                getPrefix(road.part_id) === getPrefix(roadmap.route_id)
            );
            names = filtred;
        } else {
            names = res;
        }
        return names
    }

    async function init() {
        try {
            setSelectedRouteNames([]);
            setLoading(true);
            if (busStation) {
                const names = await getRoutesByStaition();
                setIniRoutes(names);
                setRoutes(names);
            }
        }
        catch (err) {
            console.error('Error in useRoadmaps.init()', err);
            alert('Ошибка загрузки маршрутов')
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        init();
    }, [busStation, roadmap]);


    function handleSelectedRouteNames(name: string) {
        if (name === 'Все') {
            setSelectedRouteNames([]);
            return;
        }
        const newNames = [...selectedRouteNames];
        if (newNames.includes(name)) {
            newNames.splice(newNames.indexOf(name), 1);
        } else {
            newNames.push(name);
        }
        setSelectedRouteNames(newNames);
    }

    //Обновление раз в 15 секунд маршрутов, которые отображаются пользователю
    async function refreshRoutes() {
        try {
            const routesRes = await getRoutesByStaition();

            if (!routesRes || routesRes.length === 0) {
                return;
            }

            setRoutes((prev) => {
                if (!prev || prev.length < 1) return prev;

                // ключ (route_id + part_id + direction + tc_id при необходимости)
                const key = (r: IRoadmap) => `${r.route_id}_${r.part_id ?? ""}_${r.route_direction ?? ""}_${r.tc_id ?? ""}`;

                const map = new Map(routesRes.map((r) => [key(r), r]));

                // обновление/замена + удаление отсутствующих
                const next = prev
                    .map((old) => map.get(key(old)) ?? null)
                    .filter((x): x is IRoadmap => x !== null);

                // добавление новых (которых не было)
                const prevKeys = new Set(prev.map(key));
                for (const r of routesRes) {
                    if (!prevKeys.has(key(r))) next.push(r);
                }

                return next;
            });
        } catch (err) {
            console.error("refreshRoutes error", err);
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if (busStation) {
                refreshRoutes();
            }
        }, 15000);

        return () => clearInterval(interval);
    }, [busStation]);

    return ({
        initRoutes,
        routes,
        isLowFloorTransportEnabled,
        loading,
        selectedRouteNames, handleSelectedRouteNames,
    })
}

export default useRoadmapsBSI;